
  <app-navbar *ngIf="(isLoggedIn | async)"></app-navbar>
  <div *ngIf="(isLoggedIn | async)"
    [ngClass]="(isLoggedIn | async) && !commonService.isSidebarShow ? 'wrapper-outlet' :  (isLoggedIn | async) && commonService.isNavbarShow ? 'content-wrapper' : 'login-cont'">
    <div [ngClass]="(isLoggedIn | async) && commonService.isNavbarShow ? 'container-fluid' : 'height-full'">
      <router-outlet></router-outlet>
    </div>
  </div>

  <!-- <button *ngIf="_pwaService.promptEvent" (click)="installPwa()">Install</button> -->
  <div *ngIf="!(isLoggedIn | async)" class="global-loader text-center">
    <div>
      <div class="spinner-grow text-loader-color" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-loader-color" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-loader-color" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
  <footer class="footer bg-pattern text-white text-center" [style.background-image]="'url(' + bannerSrc + ')'" *ngIf="isShowFooter && commonService.isNavbarShow">
    By using our site, you acknowledge that
    you have read and understood our privacy policy. <button class="btn btn-sm" (click)="setPrivacyPolicy()">Ok</button>
    <a href="/privacy-policy" target="_blank" class="btn btn-sm ml-2">Privacy Policy</a>
  </footer>